import { render, staticRenderFns } from "./item_multiple_select.vue?vue&type=template&id=c9d674ca&"
import script from "./item_multiple_select.vue?vue&type=script&lang=js&"
export * from "./item_multiple_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports